import React from "react";
import { match } from "react-router";
import { MatchParams } from "src/routes";
import { Paper } from "src/components";
import { theme } from "src/config";
export interface IManualProps {
  match: match<MatchParams>; // This is injected so it has to be called match
}

export const Manual = (props: IManualProps): JSX.Element => {
  return (
    /* Meeting summary 1st page */
    <html>
      <body
        style={{
          display:        "flex",
          justifyContent: "center",
          flexDirection:  "column",
          fontSize:       "18px",
          width:          "110rem",
          padding:        "2rem 2rem"
        }}
      >
        <section>
          <h1 style = {{ fontSize: "32px" }}>Meeting summary</h1>
          <div
            style={{
              display:        "flex",
              justifyContent: "space-between",
              marginTop:      "2rem",
              paddingBottom:  "2rem",
              borderBottom:   "2px solid black"
            }}
          >
            <div style = {{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display:             "grid",
                  gridTemplateColumns: "1fr 1fr",
                  alignItems:          "baseline",
                  gap:                 "0.5rem"
                }}
              >
                <h2>Project: </h2>
                <p style = {{ fontSize: "22px", marginLeft: "1rem" }}>
                  Project 1
                </p>
              </div>

              <div
                style={{
                  display:             "grid",
                  gridTemplateColumns: "1fr 1fr",
                  alignItems:          "baseline"
                }}
              >
                <h2>Room: </h2>
                <p style = {{ fontSize: "22px", marginLeft: "1rem" }}>Room 2 </p>
              </div>
            </div>

            <div
              style={{
                display:             "grid",
                gridTemplateColumns: "6rem 16rem",
                alignItems:          "baseline",
                gap:                 "0.5rem",
                textAlign:           "right"
              }}
            >
              <h3>Date: </h3>
              <p>2021.02.21</p>
              <h3>Time: </h3>
              <p>13.00</p>
              <h3>Duration: </h3>
              <p>3 hours</p>
            </div>
          </div>
        </section>

        <section
          style={{
            display:        "flex",
            justifyContent: "space-between",
            marginTop:      "2rem"
          }}
        >
          <div
            style={{
              display:       "flex",
              flexDirection: "column",
              alignItems:    "baseline",
              marginRight:   "2rem"
            }}
          >
            <div style = {{ display: "flex", flexDirection: "row", alignItems:"baseline" }}>
              <h3>Instructions: </h3>
              <div style = {{ maxWidth: "60rem", overflowWrap: "break-word" }}>
              <p   style = {{ marginLeft: "0.75rem" }}>
                  asdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasasdasdasdasddasdasdasd
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              display:             "grid",
              gridTemplateColumns: "6rem 16rem",
              alignItems:          "baseline",
              gap:                 "0.75rem",
              marginLeft:          "1rem",
              textAlign:           "right"
            }}
          >
            <h3 style = {{ justifySelf: "start" }}>Title:</h3>
            <p>Monday meeting</p>
            <h3>Number: </h3>
            <p>22</p>
            <h3>Category: </h3>
            <p>short meeting</p>
          </div>
        </section>

        <section>
          <div
            style={{
              borderBottom:        "2px solid black",
              marginBottom:        "2rem",
              paddingBottom:       "2rem",
              display:             "grid",
              gridTemplateColumns: "12rem 16rem",
              alignItems:          "baseline",
              gap:                 "0.75rem"
            }}
          >
            <h3>Location: </h3>
            <p>Stockholm</p>
            <h3>Conf. link:                                     </h3>
            <a        style={{color: "darkblue"}} href="">http: //meetingLink.com</a>
          </div>
        </section>

        <section>
          <h1  style = {{marginBottom: "2rem"}}>Participants</h1>
          <div style = {{display: "grid", gridTemplateColumns: "repeat(4, 14rem)", gap: "2rem"}}>
          <div>
          <h3>Attended</h3>
          <p>Yes</p>
          </div>
          <div>
          <h3>Name</h3>
          <p>Michael Jackson</p>
          </div>
          <div>
          <h3>In</h3>
          <p>20: 12</p>
          </div>
          <div>
          <h3>Out</h3>
          <p>21: 22</p>
          </div>
          </div>
        </section>
      </body>
    </html>  

/* Meeting summary 2nd page */

 /*  <html>
      <head>
      </head>
      <body
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          fontSize: "18px",
          width: "110rem",
          padding: "2rem 2rem"
        }}
      >
        <h1>Summary</h1>

        <section>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            <div
              style={{
                alignSelf: "end",
                alignItems: "baseline",
                gap: "0.5rem",
                textAlign: "left"
              }}
            >
              <h3 style={{ marginBottom: "1rem" }}>Event Types</h3>
              <p style={{ backgroundColor: "#fefbd1", padding: "0.5rem" }}>
                <strong style={{ marginRight: "0.5rem" }}>Question:</strong>
                updated item was a question
              </p>
              <p style={{ backgroundColor: "#edf6ff", padding: "0.5rem" }}>
                <strong style={{ marginRight: "0.5rem" }}>Deliverable:</strong>
                updated item was a deliverable
              </p>
              <p style={{ backgroundColor: "#e1fbf4", padding: "0.5rem" }}>
                <strong style={{ marginRight: "0.5rem" }}>Meeting:</strong>
                attendance related events
              </p>
              <p style={{ backgroundColor: "#d7dbdf", padding: "0.5rem" }}>
                <strong style={{ marginRight: "0.5rem" }}>Other:</strong>
                other events
              </p>
            </div>
          </div>
        </section>

          <h2 style={{ marginBottom: "2rem" }}>Participants</h2>
          <table style={{textAlign: "left", border: "1px solid black"}}>
            <tr>
              <th style={{padding: "0.8rem", border: "1px solid black"}}>User Name</th>
              <th style={{padding: "0.8rem", border: "1px solid black"}}>Time</th>
              <th style={{padding: "0.8rem", border: "1px solid black"}}>Item Number</th>
              <th style={{padding: "0.8rem", border: "1px solid black"}}>Item Type</th>
              <th style={{padding: "0.8rem", border: "1px solid black"}}>Event</th>
            </tr>
            <tr>
              <td style={{padding: "0.8rem", border: "1px solid black"}}>Michael Jackson</td>
              <td style={{padding: "0.8rem", border: "1px solid black"}}>17:00</td>
              <td style={{padding: "0.8rem", border: "1px solid black"}}>2032</td>
              <td style={{padding: "0.8rem", border: "1px solid black"}}>question</td>
              <td style={{padding: "0.8rem", border: "1px solid black"}}>User left the room</td>
            </tr>
          </table>
      </body>
    </html>  */
  );
};
